/*
  Footer.jsx
*/

// Npm.
import React from 'react';

// Makes.
import { makeStyles } from '../../makes/makeStyles';

// Styles.
const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed',
    bottom: 2,
    left: 4,
    userSelect: 'none',
    pointerEvents: 'none',
    color: theme.color_text_disabled,
    fontSize: '0.8rem',  // TODO: Do font sizes correctly.
    zIndex: 1100,
  },
}));

/**
 * Bottom footer component.
 */
export default function Footer() {

  const classes = useStyles();

  return (
    <footer className={classes.root}>
      Botech © { new Date().getFullYear() }
    </footer>
  );
}
